__turbopack_context__.v({
  "container": "styles-module__l8d7Bq__container",
  "featuredContainer": "styles-module__l8d7Bq__featuredContainer",
  "heading": "styles-module__l8d7Bq__heading",
});
